// extracted by mini-css-extract-plugin
export default {"container":"ProductFeatureBlockList-module--container--e-Kv5"};